<template>
    <hts-drawer
        v-model="cVisible"
        size="90%"
        :title="drawerTitle"
        :loading="loading"
        @show="init">
        <trip-content
            v-if="!loading"
            :trip="trip" />
    </hts-drawer>
</template>
<script lang="ts" setup>
import { combineTravelDetails } from './trip-utils'
import TripContent from './trip-info-content.vue'
const props = defineProps({
  api: {
    type: Object,
    required: true
  }
})

const { $formatters, $eventBus } = useNuxtApp()
const { api } = toRefs(props)

const loading = ref(true)
const cVisible = ref(false)

const trip = reactive<any>({
  _id: '',
  code: '',
  stages: [],
  stageNames: [],
  timeIn: null,
  timeOut: null,
  vehicleId: null,
  vehicleTempId: null,
  order: {},
  routingPositions: [],
  positions: []
})
const drawerTitle = computed(() => `Thông tin chuyến #${trip.code}`)
const tripId = ref<string | null>(null)

onMounted(() => {
  $eventBus.on('trip-change', handleTripChange)
})

onUnmounted(() => {
  $eventBus.off('trip-change', handleTripChange)
})

const handleTripChange = (info: any) => {
  Object.assign(trip, info)
  refresh()
}

const getData = (silence: boolean = false) => {
  if (!silence) {
    loading.value = true
  }
  $api(api.value, { uriParams: { ID: tripId.value } }).then(({ data }: any) => {
    const temp = (data?.value || {}).data || {}

    temp.travelDetails = combineTravelDetails(temp, $formatters)
    Object.assign(trip, temp)
    nextTick(() => {
      loading.value = false
    })
  })
}

const init = () => {
  nextTick(() => {
    getData()
  })
}

const show = (id: string) => {
  Object.assign(trip, {
    _id: '',
    code: '',
    stages: [],
    stageNames: [],
    timeIn: null,
    timeOut: null,
    vehicleId: null,
    vehicleTempId: null,
    order: {}
  })
  tripId.value = id
  cVisible.value = true
}

const hide = () => {
  cVisible.value = false
}

const refresh = (id?: string) => {
  if (!cVisible.value) {
    return
  }
  if (id && tripId.value !== id) {
    return
  }

  getData(true)
}

defineExpose({
  show,
  hide,
  refresh
})
</script>
